import md5 from "md5";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/utils/utils";

interface GravatarAvatarProps {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "h-7 w-7 text-[10px]",
  md: "h-9 w-9 text-xs",
  lg: "h-11 w-11 text-sm",
};

function getInitials(
  firstName?: string | null,
  lastName?: string | null,
): string {
  const first = (firstName || "")[0] || "";
  const last = (lastName || "")[0] || "";
  return (first + last).toUpperCase() || "?";
}

function getAvatarUrl(email: string): string {
  const hash = md5(email.trim().toLowerCase());
  return `https://gravatar.com/avatar/${hash}?d=404&s=72`;
}

export default function GravatarAvatar({
  email,
  firstName,
  lastName,
  size = "md",
  className,
}: GravatarAvatarProps) {
  const initials = getInitials(firstName, lastName);
  const avatarUrl = email ? getAvatarUrl(email) : null;

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      {avatarUrl && <AvatarImage alt={initials} src={avatarUrl} />}
      <AvatarFallback
        className={cn(
          sizeClasses[size],
          "bg-gray-100 dark:bg-slate-700 text-gray-500 dark:text-gray-400 font-medium",
        )}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}
